import { Box, CardMedia, Link as MUILink, Typography, useTheme } from '@mui/material';
import map_url from '@/assets/images/api-integration/map.png'
import { Link } from 'react-router-dom';
import { FONT_SECONDARY } from '@/theme/typography';
import { options } from './mockData';

const DataSyncTabContent = () => {
  const theme = useTheme();
  return (
    <Box>
      <CardMedia 
        component='img'
        image={map_url}
        alt='map'
        sx={{
          maxWidth: '1520px',
          height: 'auto',
          marginBottom: '33px'
        }}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: { md: 'center' },
          flexDirection: { xs: 'column', md: 'row' }
        }}
      >
        <Typography
          sx={{
            fontSize: '1rem !important',
            color: theme.palette.grey[400],
            fontWeight: { xs: '600', md: '500' },
            marginRight: { md: '16px' },
            marginBottom: { xs: '12px', md: '0px'}
          }}
        >
          Developer resources:
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap'
          }}
        >
          {options.map((opt, index) => (
            <MUILink
              key={index}
              component={Link}
              to={opt.href}
              color={theme.palette.primary.main}
              sx={{
                fontFamily: FONT_SECONDARY,
                fontWeight: { xs: '700', md: '600'},
                textWrap: 'nowrap',
                ':not(:last-child)': {
                  '::after': {
                    content: '"•"',
                    marginX: '10px'
                  }
                }
              }}
            >
              {opt.label}
            </MUILink>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default DataSyncTabContent;